/**
 * Session Timer component.
 * @module components/LoginUnico/LogiUnicoSessionTimer
 */
import React, { useEffect } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { Container } from 'semantic-ui-react';
import { defineMessages, useIntl } from 'react-intl';
import { logout, purgeMessages } from '@plone/volto/actions';


const messages = defineMessages({
    sessionExpired: {
      id: 'session_expired',
      defaultMessage: 'Your session has expired.'
    },
    sessionExpiredDesc: {
      id: 'session_expired_desc',
      defaultMessage: 'You can browse the portal as a guest or log in again:',
    },
    loginAgain: {
        id: 'login_again',
        defaultMessage: 'Login again.',
      }
  });

/**
 * SessionExpired component class.
 * @function SessionExpired
 * @param {Object} intl Intl object
 * @returns {string} Markup of the component.
 */
const SessionExpired = (props) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(logout());
    dispatch(purgeMessages());
  }, [dispatch]);

  return (
    <Container id="session-expired">
      <h1 className="documentFirstHeading">{intl.formatMessage(messages.sessionExpired)}</h1>

      <p>{intl.formatMessage(messages.sessionExpiredDesc)}</p>

      <div>
        <a href="/login">{intl.formatMessage(messages.loginAgain)}</a>
      </div>
    </Container>
  );
};

export default SessionExpired;